import { put, call } from 'redux-saga/effects';
import * as actions from '../actions';
import { validateOTP } from '../../api/application';
import { submitApplicationStart } from '../actions';

export function* validateOTPSaga(action) {
    yield put(actions.registerLoading());

    let isSubmitApp = false;
    try {
        const response = yield call(validateOTP, action.sessionId, action.otp);
        yield put({ type: actions.onValidateOTPSuccess(response.data.data) });
        if (response.data.data) {
            isSubmitApp = true;
            yield put(
                submitApplicationStart(
                    action.applicationDetails,
                    action.applicantDetails,
                    action.licenseFiles,
                    action.employmentFiles
                )
            );
        }
    } catch (error) {
        if (isSubmitApp === true) {
            yield put(actions.stageSuccess(11));
        } else {
            yield put({ type: actions.onValidateOTPFailed(error.response.data) });
        }
    }

    yield put(actions.unregisterLoading());
}
